var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg006Germany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 200.946v-93.591c0-9.122-7.395-16.516-16.516-16.516h-478.968l-8.849 16.516v93.591l17.104 22.022h462.456z",
    fill: "#5d5360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 107.355v93.591l16.516 14.683v-124.79c-9.121 0-16.516 7.394-16.516 16.516z",
    fill: "#4b3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.817 311.054v86.43c0 9.122 7.395 16.516 16.516 16.516h471.151l16.516-9.355v-93.591l-24.77-22.022h-462.456z",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.516 355.097v-58.724l-16.516 14.681v93.591c0 9.122 7.395 16.516 16.516 16.516h478.968c9.121 0 16.516-7.394 16.516-16.516h-445.935c-27.365 0-49.549-22.183-49.549-49.548z",
    fill: "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.667 297 7.849 14.053h495.484v-110.107h-495.484l-7.849 17.387z",
    fill: "#e5646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 200.946h16.516v110.107h-16.516z",
    fill: "#db4655"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg006Germany);
export default __webpack_public_path__ + "static/media/006-germany.da4a6c7d4dc48074ca8ce70cadd86a27.svg";
export { ForwardRef as ReactComponent };